﻿import {$, $$, get, postData, getData, postDataJson, toggleElements, clickOnEnterKey, toggle} from "@/Utils";
import { validateForm } from "@/Validation";
import { StatusCodes } from "http-status-codes";
import { Login, Contacts } from "@/interfaces";
import {validateRegistrationEmail} from "@/RegistrationModule.js";

function secureIdReload(url: string, container: HTMLElement, model, sourceForm) {
  window.setTimeout(() => {
    secureIdFetch(url, container, model, sourceForm);
  }, 2000);
}

function secureIdFetch(url: string, container: HTMLElement, model, sourceForm) {
  const callback = (response: Response) => {
    if (response.status === StatusCodes.OK) {
      secureIdReload(url, container, model, sourceForm);
    }
    if (response.status === StatusCodes.OK || response.status === StatusCodes.UNAUTHORIZED) {
      return response.text().then(text => {
        container.innerHTML = text;
          initIdAndMobileLogin(model.isMobileId)
      });
    }
    else if (response.status === StatusCodes.IM_A_TEAPOT) {
      return response.text().then(text => {
        if (text) {
          window.location.href = text;
        }
        else {
          window.location.reload();
        }
      });
    }
    else {
      container.innerHTML = window.config.technicalErrorMessage;
    }
  }
  postData(url, model, callback);
}


function initLoginBySecureId(loginForm: HTMLFormElement, isMobileId: boolean) {
  const url = isMobileId
    ? window.config.accountEndpoints.loginByMobileIdUrl
    : window.config.accountEndpoints.loginBySmartIdUrl;
  const container = loginForm.parentElement;
  const idCodeName = isMobileId ? "MidCode" : "SidCode";

  loginForm.addEventListener("submit", e => {
    e.preventDefault();

    if (!validateForm(loginForm)) return;

    const _isRegister = get("login-panel")?.classList.contains("register");

    const model = isMobileId ?
      {
        isRegister: _isRegister,
        isMobileId: true,
        midCode: (loginForm.querySelector(`[name='${idCodeName}']`) as HTMLInputElement).value,
        mobile: (loginForm.querySelector("[name='Mobile']") as HTMLInputElement).value
      } :
      {
        isRegister: _isRegister,
        isMobileId: false,
        sidCode: (loginForm.querySelector(`[name='${idCodeName}']`) as HTMLInputElement).value,
      };

    secureIdFetch(url, container, model, loginForm);
  });
}

export function initIdAndMobileLogin(isMobileId: boolean) {
    const selectorDef = isMobileId ? "mid" : "sid"
    $$(`[data-${selectorDef}-login]`).forEach(x => {
        if (x.getAttribute(`data-${selectorDef}-login-bound`)) {
            return;
        }
        let lvIdInput = x.querySelector(".lv-id-code") as HTMLInputElement;
        if(lvIdInput != null) {
            lvIdCodeCheck(lvIdInput);
        }

        x.setAttribute(`data-${selectorDef}-login-bound`, "true");
        initLoginBySecureId(x as HTMLFormElement, isMobileId);
    });
}

function lvIdCodeCheck(x: HTMLInputElement){
    if(x.classList.contains("lv-id-code")){
        const eventHandler = () => {
            let inputValue = (x as HTMLInputElement).value;
            inputValue = inputValue.replace(/[^0-9\-]/g, '');
            if(inputValue.length >= 7 && !inputValue.includes("-")) {
                inputValue = inputValue.slice(0, 6) + "-" + inputValue.slice(6);
            }

            (x as HTMLInputElement).value = inputValue;
        }
        x.addEventListener('input', eventHandler);
    }
}

function initLoginByEmail() {
    
    $$('[name="email-login"]')?.forEach( form => {
        const loginForm = form as HTMLFormElement;
        loginForm?.addDataBoundEventListener("submit",
            event => {
            
                const email = (loginForm.querySelector('[name="email"]') as HTMLInputElement)?.value;
                const renewLink = (loginForm.querySelector('[name="RenewActivationLink"]') as HTMLInputElement)?.value;
                event.preventDefault();
                if (!validateForm(loginForm)) return;
                if (get("login-panel")?.classList.contains("register") ?? false) {
                    validateRegistrationEmail(email, loginForm);
                } else {
                    const model = {
                        renewActivationLink: renewLink === "true",
                        password: (loginForm.querySelector('[name="Password"]') as HTMLInputElement)?.value,
                        contacts: {
                            email: email,
                        } as Contacts
                    } as Login;
                    const callback = (resp: Response) => {
                        if (resp.status === StatusCodes.OK) {
                            return window.location.reload();
                        }
                        else {
                            return resp.text().then(text => {
                                $$('[name="loginByEmail"]')?.forEach(elem => {
                                    elem.innerHTML = text;
                                })
                                initLoginByEmail();
                                initRenewActivationLink();
                            });
                        }
                    }
                    postData(window.config.accountEndpoints.loginUrl, model, callback);
                }
            });
    });  
}

function initLoginByIdCard() {

  $$("[data-login]").forEach(loginPanel => {

    const link = loginPanel.querySelector(".id-login") as HTMLAnchorElement;

    link?.addEventListener("click", () => {

      if (loginPanel.classList.contains("register")) {
        document.location.href = link.getAttribute("id-card-url-registration");
      }
      else {
        document.location.href = link.getAttribute("id-card-url");
      }
    });
  });

}

function initRenewActivationLink() {
    
    $$('[name="email-login"]')?.forEach(form => {
        const loginForm = form as HTMLFormElement;

        const link = loginForm?.querySelector(".renew-activation-link");
        link?.addEventListener("click", () => {
            (loginForm.querySelector("[name='RenewActivationLink']") as HTMLInputElement)?.setAttribute("value", "true");            
            const btn = loginForm.querySelector("[name='submit-login']") as HTMLButtonElement;
            btn.click();
        });
    });
}

function initLogout() {
  get("logout").addEventListener("click", () => {
    getData(window.config.accountEndpoints.logoutUrl, () => window.location.reload());
  });
}

function changeButtonTexts(e: Event) {
    const text = (e.currentTarget as HTMLElement).querySelector("a").getAttribute("data-button-text");
  const altTextCandidates = document.querySelectorAll("[data-reglog-alt-text]");
  altTextCandidates.forEach(x => {
      const spn = x.querySelector("span");
      spn.innerHTML = text;
  });
}

function changeLoginDescription(isLogin: boolean) {
    
    const toggleDescriptions = [
        { element: '[name="secure-description-login"]', show: isLogin },
        { element: '[name="secure-description-register"]', show: !isLogin },
        { element: '[name="description-login"]', show: isLogin },
        { element: '[name="description-register"]', show: !isLogin }
    ];    

    toggleElements(toggleDescriptions);
}

function initRegAltTabs() {

    const loginPanel = '#login-panel';
    const secureLoginPanel = '#secure-login-panel';
    const cartPanelWrapper = '#cart-panel-wrapper';

    const loginAndRegisterTabs = [
        {tabId: '#login-tab', panels: [loginPanel, cartPanelWrapper], isLogin: true},
        {tabId: '#register-tab', panels: [loginPanel, cartPanelWrapper], isLogin: false},
        {tabId: '#secure-login-tab', panels: [secureLoginPanel, cartPanelWrapper], isLogin: false},
        {tabId: '#secure-register-tab', panels: [secureLoginPanel, cartPanelWrapper], isLogin: false}
    ];

    loginAndRegisterTabs.forEach((tab: { tabId: string, panels: [], isLogin: boolean }) => {
        $$(tab.tabId).forEach(tabContent => {
            const tabElement = tabContent.closest("[role='tab']") as HTMLElement
            tabElement.addEventListener("click", e => {
                changeTexts(tab, e);
            });
            tabElement.addDataBoundEventListener("keydown", e => {
                clickOnEnterKey(e, tabElement)
            }, "enter-keypress-bound");
        });
    });
}

function changeTexts(tab: { tabId: string, panels: [], isLogin: boolean }, e: Event){
    tab.panels.forEach(panel => {
        $$(panel).forEach(element => {
            element.classList[tab.isLogin ? "remove" : "add"]("register");
        });
    });
    toggle($(".register-captcha-container") as HTMLElement, !tab.isLogin);
    $$('[name="email-login"]')?.forEach(x => x.classList.toggle("form-captcha-invalid", !tab.isLogin && !x.classList.contains("form-captcha-valid")))
    changeButtonTexts(e);
    changeLoginDescription(tab.isLogin);
}

function initLoginPanelDescription() {
  changeLoginDescription(true);
}

function initLoginTab() {
    if (window.isResponsive) {
        get("login-panel")?.querySelector(".tabs-menu__item--active")?.classList.remove("tabs-menu__item--active");
        
        get("login-panel")?.querySelectorAll(".tabs-menu__item")?.forEach(x => x.addEventListener("click", () => {
            $(".login__wrapper").classList.remove("narrow-d-none");
        }));
    }
}

export function initLogin() {
  initLoginByIdCard();

  if (get("logout")) {
    initLogout();
    return;
  }

  initIdAndMobileLogin(true);
  initIdAndMobileLogin(false);
  initLoginByEmail();
  initRegAltTabs();
  initRenewActivationLink();
  initLoginPanelDescription();
  initLoginTab();
}